import Api from "./api";

class FeedbackService {
  async sendFeedbacks(selectedProject, feedback, mun) {
    const apiUrl = selectedProject
      ? `${mun}/projects/${selectedProject}/feedbacks`
      : `${mun}/contact`;

    try {
      let res = await Api.post(apiUrl, feedback);
      return res.body;
    } catch (error) {
      throw error;
    }
  }
}

export default new FeedbackService();



// WEBPACK FOOTER //
// ./src/api/feedbackService.js